import { Link } from 'react-router-dom';

import { Divider, Flex } from '@spotify-internal/encore-web';
import { AuthScreen } from '@spotify/confidence-core-react';

import { AuthConnectionsSection } from './AuthConnectionsSection';
import { useAuthConnectionsContext } from './CreateAccountFormProvider';
import { CreateWorkspaceFooter } from './CreateWorkspaceFooter';
import { RegionSection } from './RegionSection';
import { WorkspaceNameFields } from './WorkspaceNameFields';

import styles from './WorkspaceSetupForm.module.css';

export const WorkspaceSetupForm = () => {
  const { showAuthConnections } = useAuthConnectionsContext();

  return (
    <AuthScreen.Root>
      <AuthScreen.Main>
        <div className={styles.wrapper}>
          <Flex
            className={styles.header}
            direction="column"
            gap="looser-3"
            alignItems="center"
          >
            <Link to="/" aria-label="Go to homepage" data-track-source-anchor="db2ce8e2b2">
              <AuthScreen.Logo />
            </Link>
            <Flex direction="column" gap="tighter-3" alignItems="center">
              <AuthScreen.Title>Set up your workspace</AuthScreen.Title>
              <AuthScreen.Description>
                Choose your workspace name carefully. It can&apos;t be changed
                later.
              </AuthScreen.Description>
            </Flex>
          </Flex>

          <WorkspaceNameFields />

          {showAuthConnections && (
            <section className={styles.section}>
              <Divider className={styles.divider} />
              <AuthConnectionsSection />
            </section>
          )}

          <section className={styles.section}>
            <Divider className={styles.divider} />
            <RegionSection />
          </section>

          <section className={styles.section}>
            <Divider className={styles.divider} />
            <CreateWorkspaceFooter />
          </section>
        </div>
      </AuthScreen.Main>
    </AuthScreen.Root>
  );
};
